import { Add as AddIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useRouter } from "@tanstack/react-router";

interface BtnMoveProps {
  to?: string;
  text?: string;
  onClick?: () => void;
  typeValue?: string;
}

const BtnMove: React.FC<BtnMoveProps> = ({ to, text, typeValue, ...props }) => {
  const router = useRouter();
  const search = router.state.location.search;

  const handleClick = () => {
    router.navigate({
      to,
      search: { ...search, type: typeValue },
    });
  };

  return (
    <Button
      variant='contained'
      startIcon={<AddIcon />}
      onClick={handleClick}
      sx={{
        bgcolor: "primary.main",
        "&:hover": {
          bgcolor: "primary.dark",
        },
        minWidth: "120px",
        height: "40px",
      }}
      {...props}
    >
      {text}
    </Button>
  );
};

export default BtnMove;
